import { PatientDocumentCategory, TemplateType } from '../api/created/documents.ts';

interface DocumentTemplateOption {
  label: string;
  value: TemplateType;
}

export const TB_CASE_DOCUMENT_CATEGORIES: readonly PatientDocumentCategory[] = [
  PatientDocumentCategory.INDEX_PATIENT,
  PatientDocumentCategory.DOT,
  PatientDocumentCategory.OTHERS,
];

export const CONTACT_TRACING_DOCUMENT_CATEGORIES: readonly PatientDocumentCategory[] = [
  PatientDocumentCategory.CONTACT_TRACING,
  PatientDocumentCategory.OTHERS,
];

export const SCREENING_DOCUMENT_CATEGORIES: readonly PatientDocumentCategory[] = [
  PatientDocumentCategory.SCREENING,
  PatientDocumentCategory.OTHERS,
];

export const DOCUMENT_TEMPLATES_BY_CATEGORY: Record<PatientDocumentCategory, DocumentTemplateOption[]> = {
  [PatientDocumentCategory.DOT]: [
    { label: 'DOT-Auftrag', value: TemplateType.DOT_AUFTRAG },
    { label: 'DOT-Überwachungstabelle', value: TemplateType.DOT_UEBERWACHUNGSTABELLE },
    { label: 'DOT-Verordnung', value: TemplateType.DOT_VERORDNUNG },
  ],
  [PatientDocumentCategory.INDEX_PATIENT]: [
    { label: 'IP_Abschlussgespräch', value: TemplateType.IP_ABSCHLUSSGESPRAECH },
    { label: 'IP_Formular Zwischenbericht', value: TemplateType.IP_ZWISCHENBERICHT },
  ],
  [PatientDocumentCategory.SCREENING]: [
    { label: 'SP_Bestätigung Screening Deutsch', value: TemplateType.SP_BESTAETIGUNG_DE },
    { label: 'SP_Bestätigung Screening English', value: TemplateType.SP_BESTAETIGUNG_EN },
    { label: 'SP_Bestätigung Screening französisch', value: TemplateType.SP_BESTAETIGUNG_FR },
    { label: 'SP_Bestätigung Screening spanisch', value: TemplateType.SP_BESTAETIGUNG_ES },
    { label: 'SP_Bluttest negativ', value: TemplateType.SP_BLUTTEST_NEGATIV },
    {
      label: 'SP_Einwilligung Datenschutzerklärung',
      value: TemplateType.SP_EINWILLIGUNG_DATENSCHUTZ,
    },
    { label: 'SP_Quittung', value: TemplateType.SP_QUITTUNG },
    { label: 'SP_Rx-Karte BAZ', value: TemplateType.SP_RX_KARTE_BAZ },
    { label: 'SP_Thorax-Röntgenkarte', value: TemplateType.SP_THORAX_ROENTGENKARTE },
  ],
  [PatientDocumentCategory.CONTACT_TRACING]: [
    { label: 'UU_Aufgebot mit Termin.docx', value: TemplateType.UU_AUFGEBOT_MIT_TERMIN },
    { label: 'UU_Aufgebot ohne Termin.docx', value: TemplateType.UU_AUFGEBOT_OHNE_TERMIN },
    { label: 'UU_Auftrag überkantonale UU.docx', value: TemplateType.UU_AUFTRAG_UEBERKANTONAL },
    { label: 'UU_Bericht an HA bei MDR-UU.docx', value: TemplateType.UU_BERICHT_HA_MDR },
    {
      label: 'UU_Bericht an HA bei St.n.TB_TBI.docx',
      value: TemplateType.UU_BERICHT_HA_STN_TB_TBI,
    },
    { label: 'UU_Bluttest negativ.docx', value: TemplateType.UU_BLUTTEST_NEGATIV },
    { label: 'UU_Formular Abschluss TBI-Therapie.docx', value: TemplateType.UU_TBI_ABSCHLUSS },
    { label: 'UU_Formular Start TBI-Therapie.docx', value: TemplateType.UU_TBI_START },
    { label: 'UU_Thorax-Röntgenkarte.docx', value: TemplateType.UU_THORAX_ROENTGENKARTE },
    {
      label: 'UU_Überweisung Kinder ans KISPI_KSW.docx',
      value: TemplateType.UU_UEBERWEISUNG_KISPI_KSW,
    },
    { label: 'UU_Uberweisung TBI an HA.docx', value: TemplateType.UU_UEBERWEISUNG_TBI_HA },
  ],
  [PatientDocumentCategory.OTHERS]: [{ label: 'Kurzbrief', value: TemplateType.KURZBRIEF }],
};

export function getDocumentCategoryName(category: PatientDocumentCategory) {
  switch (category) {
    case PatientDocumentCategory.DOT:
      return 'DOT';
    case PatientDocumentCategory.INDEX_PATIENT:
      return 'Indexpatient';
    case PatientDocumentCategory.SCREENING:
      return 'Screening';
    case PatientDocumentCategory.CONTACT_TRACING:
      return 'Umgebungsuntersuchung';
    case PatientDocumentCategory.OTHERS:
      return 'Others';
  }
}
